import { Injectable } from "@angular/core";
import { ObjectValueListDto } from "../dtos/object-value.types";
import { HttpBaseService } from "./http-base.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ObjectValueService extends HttpBaseService {
    private readonly baseEndpoint = 'api/ObjectValues';

    public getValuesByDefinitionId(objectDefinitionId: string): Observable<ObjectValueListDto[]> {
        return this.get<ObjectValueListDto[]>(`${this.baseEndpoint}/${objectDefinitionId}`);
    }
}